import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesLoaded';

  let grid = null

  function initIsotope() {
    imagesLoaded('.js-isotope-grid', () => {
      grid = new Isotope('.js-isotope-grid', {
        itemSelector: '.js-isotope-item',
        percentPosition: true,
        layoutMode: 'fitRows',
        resize: true,
        stagger: 30,
        transitionDuration: '0.4s',
        masonry: {
          gutter: 10
        }
      })

      grid.on('arrangeComplete', () => {
        activeFilters()
      })
    })

    isotopeController();
  }

  function isotopeController() {
    const filterNav = document.querySelector('.js-sort');

    
    filterNav.addEventListener('click', (event) => {
      if (event.target.classList.contains('.js-sort-item') || event.target.closest('.js-sort-item')) {  

        let target = event.target.closest('.js-sort-item');

        filterNav.querySelectorAll('.js-sort-item').forEach((item) => {
          item.classList.remove('is-active');
        });
        event.target.parentElement.classList.add('is-active');

        console.log(target);
        // this.productFilterHandler(event.target.parentElement);
        productFilterHandler(target);
      }
    });
  }

  function activeFilters() {
    const filteredItems = grid.getFilteredItemElements();

    filteredItems.forEach((item, index) => {
      item.dataset.index = index;
    });

    // initLightbox(filteredItems);
  }

  function productFilterHandler(el) {
    
    const filterValue = el.getAttribute('data-filter');
    // console.log(el);
    grid.arrange({ filter: '.' + filterValue });
  }


document.addEventListener('DOMContentLoaded', () => {


  console.log('loaded')
  initIsotope();
  
});